<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add"
      >新增</a-button
    >
    <a-modal v-model="visible" centered title="添加管理员" @ok="handleOk">
      <p>账号</p>
      <a-input v-model="form.loginNo"></a-input>
      <p>昵称</p>
      <a-input v-model="form.name"></a-input>
      <p>登录密码</p>
      <a-input-password v-model="form.loginPwd"></a-input-password>
      <p>确认密码</p>
      <a-input-password v-model="Pwd"></a-input-password>
      <p>角色名称</p>
      <a-select
        v-model="form.role"
        default-value=""
        style="width: 100%"
        @change="handleChange"
      >
        <a-select-option
          v-for="(item, index) in xiala"
          :key="index"
          :value="item.id"
        >
          {{ item.roleName }}
        </a-select-option>
      </a-select>
      <p>手机号码</p>
      <a-input v-model="form.loginPhone"></a-input>
      <p>邮箱</p>
      <a-input v-model="form.emial"></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑管理员" @ok="handleOktwo">
      <p>账号</p>
      <a-input v-model="forms.loginNo"></a-input>
      <p>昵称</p>
      <a-input v-model="forms.name"></a-input>
      <p>新密码</p>
      <a-input-password v-model="newLoginPwd"></a-input-password>
      <p>角色名称</p>
      <a-select
        v-model="forms.role"
        default-value=""
        style="width: 100%"
        @change="handleChange"
      >
        <a-select-option
          v-for="(item, index) in xiala"
          :key="index"
          :value="item.id"
        >
          {{ item.roleName }}
        </a-select-option>
      </a-select>
      <p>手机号码</p>
      <a-input v-model="forms.loginPhone"></a-input>
      <p>邮箱</p>
      <a-input v-model="forms.email"></a-input>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <!-- 商品图片 -->
      <template slot="pic2" slot-scope="text, record">
        <img class="img2" :src="record.goodsRecord[0].goodsImg" alt="" />
      </template>
      <template slot="goodsName" slot-scope="text, record">
        <span>{{ record.goodsRecord[0].goodsName }}</span>
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  permissionsList,
  permissionsListXiala,
  permissionsAddAccount,
  permissionsEditAccount,
  permissionsDelAccount,
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "管理员编号",
    dataIndex: "objId",
    // sorter: true,
    align: "center",
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "账号",
    dataIndex: "loginNo",
    align: "center",
    scopedSlots: { customRender: "loginNo" },
  },
  {
    title: "昵称",
    dataIndex: "name",
    align: "center",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "手机号",
    dataIndex: "loginPhone",
    align: "center",

    scopedSlots: { customRender: "loginPhone" },
  },

  {
    title: "邮箱",
    dataIndex: "email",
    // sorter: true,
    align: "center",
    // width: "10%",
    scopedSlots: { customRender: "email" },
  },

  {
    title: "角色名称",
    dataIndex: "roleName",
    // sorter: true,
    align: "center",

    // width: "15%",
    scopedSlots: { customRender: "roleName" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      visibletwo: false,
      limit: 10,
      page: 1,
      goodsRecord: [],
      Pwd: "",
      form: {
        loginNo: "",
        loginPhone: "",
        loginPwd: "",
        name: "",
        role: "",
      },
      forms: {
        loginNo: "",
        loginPhone: "",
        loginPwd: "",
        name: "",
        role: "",
        objId: "",
      },
      newLoginPwd: ""
    };
  },
  mounted() {
    // this.getUserListDetails();
    this.getData();
    this.getpermissionsListXiala();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    getpermissionsListXiala() {
      permissionsListXiala().then((res) => {
        this.xiala = res.data;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      permissionsList({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          this.loading = false;
        }
      );
    },
    edit(row) {
      this.newLoginPwd = '';
      this.visibletwo = true;
      this.forms.objId = row.objId;
      this.forms.email = row.email;
      this.forms.role = row.role;
      this.forms.name = row.name;
      this.forms.loginPwd = row.loginPwd;
      this.forms.loginPhone = row.loginPhone;
      this.forms.loginNo = row.loginNo;
    },
    // 查询
    query() {
      this.loading = true;
      permissionsList(this.formInline).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      permissionsDelAccount(row.objId).then((res) => {
        this.loading = false;
        this.getData();
        message.success(res.info);
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    add() {
      this.form = {};
      this.form.name = "";
      this.form.loginPwd = "";
      this.Pwd = "";
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      if (this.form.loginPwd.trim() === this.Pwd.trim()) {
        permissionsAddAccount(this.form).then((res) => {
          message.success(res.info);
          this.getData();
          this.form = {};
          this.Pwd = "";
        });
      } else {
        message.warning("两次输入的密码不一致");
      }
    },
    handleOktwo() {
      if(this.newLoginPwd != ''){
        this.forms.loginPwd = this.newLoginPwd
      }
      this.visibletwo = false;
      permissionsEditAccount(this.forms).then((res) => {
        message.success(res.info);
        this.getData();
      });
    },
    getData() {
      permissionsList({ page: 1, limit: 10 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    handleChange(value) {
    },
  },
};
</script>
<style scoped>
.img2 {
  width: 100px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/right/permissions/permissionsContent.vue